import React, { useEffect, useState, useCallback } from "react";
import { getBlogList } from "../../Services/BlogService";
import Loader from "../../Components/Core/Loader";
import BlogCard from "./BlogCard";
import SeoHead from "../../Components/Core/SeoHead";
import { useTenantContent } from "../../Context/TenantContentContext";
import { doctorDisplayName, joinUrl } from "../../utils/seo";

const BlogIndex = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);
  const { content } = useTenantContent();

  const fetchData = useCallback(async () => {
    setLoading(true);
    setFailed(false);
    try {
      const response = await getBlogList();
      setBlogs(response);
    } catch (error) {
      console.error("Error fetching data:", error);
      setFailed(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const siteName = content?.siteName || "سایت پزشک";
  const doctorName = doctorDisplayName(content);
  const pageUrl = joinUrl(content?.canonicalUrl, "blog/index");
  const pageTitle = `مقالات پزشکی | ${doctorName}`;
  const pageDescription = `جدیدترین مقالات علمی و دانستنی‌های پزشکی${
    content?.doctorSpecialty ? ` در زمینه ${content.doctorSpecialty}` : ""
  } توسط ${doctorName}.`;

  return (
    <>
      {content && (
        <SeoHead
          title={pageTitle}
          description={pageDescription}
          keywords={content.siteKeywords}
          canonical={pageUrl}
          image={content.ogImage || content.doctorImageUrl}
          imageAlt={doctorName}
          siteName={siteName}
        />
      )}
      <div className="blog-index-page" dir="rtl">
        <header className="blog-index-header"><h1>آخرین مقالات</h1></header>
        {loading ? <Loader /> : failed ? (
          <div className="blog-index-status" role="alert">
            دریافت مقالات انجام نشد.
            <button type="button" onClick={fetchData}>تلاش دوباره</button>
          </div>
        ) : <BlogCard articles={blogs} />}
      </div>
    </>
  );
};

export default BlogIndex;
